import * as React from "react";
import type { SVGProps } from "react";
const SvgVipStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={27}
    fill="none"
    {...props}
  >
    <g filter="url(#vip-star-icon_svg__a)">
      <path
        fill="url(#vip-star-icon_svg__b)"
        d="M13.683 6.122a.25.25 0 0 1 .429 0l2.364 3.928a.25.25 0 0 0 .158.115l4.467 1.035a.25.25 0 0 1 .133.407l-3.006 3.463a.25.25 0 0 0-.06.186l.396 4.568a.25.25 0 0 1-.347.252l-4.222-1.789a.25.25 0 0 0-.195 0l-4.222 1.789a.25.25 0 0 1-.347-.252l.397-4.568a.25.25 0 0 0-.06-.186L6.56 11.607a.25.25 0 0 1 .133-.407l4.467-1.035a.25.25 0 0 0 .158-.114z"
      />
    </g>
    <defs>
      <linearGradient
        id="vip-star-icon_svg__b"
        x1={19.716}
        x2={9.534}
        y1={2.13}
        y2={21.766}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC120" />
        <stop offset={1} stopColor="#FFE792" />
      </linearGradient>
      <filter
        id="vip-star-icon_svg__a"
        width={26.795}
        height={26.096}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.831373 0 0 0 0 0.239216 0 0 0 0.8 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11064_11426"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11064_11426"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgVipStarIcon;
